/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class NoExpUnitDto {
  public id: string = undefined;
  public code: string = undefined;
  public name: string = undefined;
  public isDefault: boolean;
  public isImport: boolean;
  public isExport: boolean;

  //<custom-body>
  public constructor(data: NoExpUnitDto) {
    Object.assign(this, data);
  }

  public get text(): string {
    return `[${this.code}] ${this.name}`;
  }
  //</custom-body>
}
